// WB-M1A -- the board's text font (doc 25 §1.4, conditions 1 and 2).
//
// Excalidraw draws text of font family 2 with the canvas font string
// "Helvetica, ...", and Persian glyphs then come from whatever system font the
// device falls back to -- measured 7% to 30% apart between fallbacks. Aliasing
// the WHOLE "Helvetica" family to Vazirmatn makes the board's text and its
// metrics the same on every device, so a board written on one opens the same
// on another.
//
// An `@font-face` rule is document-wide, so the alias is registered through
// the FontFace API only while a board is mounted and removed again after the
// last one is gone -- nothing outside the Workspace keeps it.

import vazirmatnRegularUrl from 'vazirmatn/fonts/webfonts/Vazirmatn-Regular.woff2'

export const BOARD_FONT_FAMILY = 'Helvetica'
// Excalidraw's own id for the "Helvetica" family (its FONT_FAMILY map).
export const BOARD_FONT_FAMILY_ID = 2

let aliasFace = null
let users = 0

function supported() {
  return (
    typeof window !== 'undefined' &&
    typeof window.FontFace === 'function' &&
    typeof document !== 'undefined' &&
    !!document.fonts &&
    typeof document.fonts.add === 'function'
  )
}

/**
 * Registers the alias and resolves once it can actually draw -- the editor
 * must not mount before that, or its first text metrics are the fallback's.
 * @returns {Promise<boolean>} whether the alias is active
 */
export async function acquireBoardFont() {
  if (!supported()) return false
  users += 1
  try {
    if (!aliasFace) {
      aliasFace = new window.FontFace(
        BOARD_FONT_FAMILY,
        `url(${vazirmatnRegularUrl}) format('woff2')`
      )
      document.fonts.add(aliasFace)
    }
    await aliasFace.load()
    await document.fonts.load(`20px ${BOARD_FONT_FAMILY}`, 'سلام x=2')
    return true
  } catch (err) {
    return false
  }
}

export function releaseBoardFont() {
  if (!supported()) return
  users = Math.max(0, users - 1)
  if (users === 0 && aliasFace) {
    document.fonts.delete(aliasFace)
    aliasFace = null
  }
}
